module.exports = __webpack_public_path__ + "img/email-hover.5ec07dfa.png";